<!--
  --
  -- 送迎・配車サービス選択シート
  --
  -->
<template>
  <c-base-sheet>
    <!-- ラベル -->
    <template #caption>{{caption}}</template>

    <!-- 説明 -->
    <template #description>
      <span v-html="service.desc"/>
    </template>

    <!-- コンテンツ -->
    <template>
      <!-- 値入力 -->
      <c-pick-select :service="service"/>

      <!-- 場所入力 -->
      <c-pick-place :service="service" :label="placeLabel"/>
    </template>
  </c-base-sheet>
</template>

<script>
import CBaseSheet from '../CBaseSheet'
import CPickSelect from './CPickSelect'
import CPickPlace from './CPickPlace'

export default {
  name: 'CPickSheet',

  components: {
    CBaseSheet,
    CPickSelect,
    CPickPlace
  },

  props: {
    caption: {
      type: String
    },
    placeLabel: {
      type: String
    },
    service: {
      type: Object,
      required: true
    }
  }
}
</script>
